import * as React from 'react'
import {
  FaApplePay,
  FaCcAmex,
  FaCcMastercard,
  FaCcPaypal,
  FaCcVisa,
  FaGooglePay,
} from 'react-icons/fa'
import { Link } from 'gatsby'
import Logo from '../../../../icons/logo'
import ContentContainer from '../../../content/ContentContainer/ContentContainer'
import {
  blurb,
  copyright,
  footerNavList,
  footerNavListItem,
  footerStyle,
  links,
  logos,
  paymentLogo,
} from './alt-footer.module.scss'

export function AltFooter() {
  return (
    <ContentContainer>
      <footer className={footerStyle}>
        <div className={blurb}>
          <div
            className={`d-flex justify-content-between mb-3 flex-row ${paymentLogo}`}
          >
            <FaGooglePay></FaGooglePay>
            <FaApplePay></FaApplePay>
            <FaCcVisa></FaCcVisa>
            <FaCcMastercard></FaCcMastercard>
            <FaCcAmex></FaCcAmex>
            <FaCcPaypal></FaCcPaypal>
          </div>
          <Link to='/' aria-label='RubberFlooring4U'>
            <div className={logos}>
              <Logo />
            </div>
          </Link>
        </div>
        <div className={copyright}>
          Copyright &copy; {new Date().getFullYear()} · All rights reserved
        </div>
      </footer>
    </ContentContainer>
  )
}
